import { tw } from 'utils/classnames'

import { useHeaderContext } from '../contexts/header-config-context'
import { DesktopHeader } from './desktop'
import { MobileHeader } from './mobile'
import { useUserLanguageRedirect } from '../hooks/use-user-language-redirect'
import { NavigatorLanguageRedirect } from '../hooks/use-navigator-language-redirect'
import { MenuForSeo } from './nav-for-seo'
import { ProductHistoryStore } from './product-history-store'
import { Popups } from './promo-popups'
import { SessionNavigationCounter } from './session-navigation-counter'

interface TopHeaderProps {
  className?: string
  mainNavigation?: React.ReactNode
  hamburgerMenu?: React.ReactNode
}

export const Header = ({ className, mainNavigation, hamburgerMenu }: TopHeaderProps) => {
  // TODO: After GROW-1163 cleanup we can use the hook directly
  //useNavigatorLanguageRedirect()
  useUserLanguageRedirect()
  const { lang, activeCurrency } = useHeaderContext()

  return (
    <header className={tw('bg-cf-white relative', className)}>
      {/* Hidden input to store the active language and currency, needed by wordpress */}
      <input id="active-language" type="hidden" name="language" value={lang} />
      <input
        id="active-currency"
        type="hidden"
        name="currency"
        value={activeCurrency?.code ?? ''}
      />
      <SessionNavigationCounter />
      <ProductHistoryStore />
      <DesktopHeader mainNavigation={mainNavigation} />
      <MobileHeader hamburgerMenu={hamburgerMenu} />
      <MenuForSeo />
      <Popups />
      <NavigatorLanguageRedirect />
    </header>
  )
}
